import React, { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import {
  ContentLayout,
  Header,
  Container,
  SpaceBetween,
} from "@amzn/awsui-components-react-v3/polaris";
import { PageLayout } from "../components/page-layout";
import { useRegister } from "../hooks/webauthn";
import { RegisterMfaForm } from "../components/register-mfa-form";
import { Alerts } from "../components/alerts";
import { Alerts as AlertsType } from "../lib/types";
import { RegistrationMessages, PagePaths } from "../lib/constants";
import { Breadcrumbs } from "../components/breadcrumbs";
import { AlternativeDomainRegistrationAlert } from "../components/alternative-domain-registration-alert";

const breadcrumbItems = [
  { href: "#", text: "Key Management" },
  { href: PagePaths.REGISTER_MFA, text: "Register security key" },
];

export const RegisterMFA = () => {
  const auth = useAuth();
  const [alerts, setAlerts] = useState<AlertsType>({});
  const { register, error, isSuccess } = useRegister();
  const username = auth.user?.profile?.preferred_username as string | undefined;

  useEffect(() => {
    if (isSuccess) {
      setAlerts((prevAlerts) => ({
        ...prevAlerts,
        successfully_registered_alert: {
          message: RegistrationMessages.SECURITY_KEY_REGISTERED_SUCCESS,
          ariaLabel: "Success",
          type: "success",
        },
      }));
    }
  }, [isSuccess]);

  return (
    <PageLayout auth={auth}>
      <ContentLayout
        notifications={
          <SpaceBetween size="s">
            <Alerts items={alerts} />
            {isSuccess && (
              <AlternativeDomainRegistrationAlert alias={username} />
            )}
          </SpaceBetween>
        }
        breadcrumbs={<Breadcrumbs items={breadcrumbItems} />}
        headerVariant="high-contrast"
        header={<Header variant="h1">Security Key Registration</Header>}
        defaultPadding
      >
        <Container
          header={<Header variant="h2">Register a new security key</Header>}
        >
          <RegisterMfaForm
            error={error}
            isSuccess={isSuccess}
            onSubmit={register}
            isChromium={window.chrome}
          />
        </Container>
      </ContentLayout>
    </PageLayout>
  );
};
